export default "__VITE_ASSET__DpxmoB92__"